// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cbRm0","toggleWrap":"styles_toggleWrap__2jEW2","content":"styles_content__2x3fr","selectAreaCode":"styles_selectAreaCode__31fCT"};